import { IOrderDetailInfo } from "@/models/IManagement"

const orderInfo: IOrderDetailInfo = {
  tracking_id: 0,
  all_weight: 0,
  is_select_shipping_method_later: 0,
  is_tracking: 0,
  label_fee: 0,
  pickup: {
    address: {
      address1: "",
      address2: "",
      apartment: "",
      city: "",
      country: "",
      country_code: "",
      email: "",
      first_name: "",
      full_address: "",
      last_name: "",
      latitude: 0,
      longitude: 0,
      name: "",
      phone: "",
      province: "",
      province_code: "",
      zip: "",
    },
    carrier: "",
    code: "",
    date: "",
    status: "",
    time: "",
    timezone: "",
  },
  return_address: {
    address: "",
    address_detail: "",
    full_address: "",
    city: "",
    country: "",
    email: "",
    name: "",
    phone: "",
    province: "",
    zip: "",
  },
  rewards_code: "",
  shipping_status: 0,
  success_flow_run_id: 0,
  weight_unit: "",
  currency: "-",
  currency_format: "-",
  customer_info: {
    customer_name: "-",
    customer_email: "-",
    customer_phone: "-",
    wise_iban: "",
    wise_name: "",
    account_number: "",
    account_holder_name: "",
    bank_identifier: "",
  },
  discount: 0,
  id: 0,
  max_refund: 0,
  order_no: "-",
  order_record_id: 0,
  refund: 0,
  real_money: 0,
  request_date: 0,
  rma: "-",
  shipping_carrier: "-",
  shipping_method_id: 0,
  shipping_method_text: "-",
  solution_id: 0,
  solution_text: "-",
  status: 1,
  tax: 0,
  total: 0,
  return_moneys: {
    adjust_val: 0,
  },
  work_flow_refresh: {
    apply: false,
    continue: false,
  },
  tracking_number: "-",
  no_received_quantity: 0,
  no_restocked_quantity: 0,
  total_quantity: 0,
  has_use_integration: false,
  has_many: false,
  type: 1,
  exchange_order_name: "-",
  carrier_code: "",
  return_label: "",
  taxes_included: 0,
  is_label_url: 0,
  return_shipment_proof: [],
  exchange_order_id: 0,
  return_label_link: "",
  tags: [],
  shopify_order_url: "",
  invoice_url: "", // 发票打印链接
  return_rewards: 0,
  return_rewards_method: 0,
  return_rewards_shop_amount: 0,
  is_refund: 0,
  refund_shipping_type: 0,
  refund_status_text: "",
  is_test_mode: false,
  label_fee_kind: 1,
  estimate_label_fee: false,
  gift_balance: 0,
  gift_card_used: false,
  rewards_gift_info: {
    gift_balance: 0,
    gift_card_used: false,
    gift_balance_plain: 0,
    initial_value_plain: 0,
    gift_card_currency: "",
  },
  total_shipping_cost: 0,
  exchange_order: {
    draft_order_id: 0,
    total_line_items_price: "",
    discount_amount: "",
    remain_credit: "",
    total_price: "",
    order_id: 0,
    order_name: "",
    line_items: [],
    shopify_refund: "",
    exchange_total: 0,
    tax_present: 0,
    origin_subtotal: 0,
    origin_tax: 0,
    total_price_set: {
      presentmentMoney: {
        amount: "0.00",
        currencyCode: "",
      },
      shopMoney: {
        amount: "0.00",
        currencyCode: "",
      },
    },
    tax_estimate: "0.00",
    exchange_order_currency_symbol: "",
    taxes_included: 0,
    remain_credit_after_shop: 0,
    exchange_credit: "0.00",
  },
  refund_process_status: -1,
  need_create_exchange_order: 0,
  return_label_file: undefined,
  tracking: [],
  line_label_fee: "",
  line_return_fee: "",
  archive_status: 0,
  shipping_amount: {
    money: 0,
    tax: 0,
  },
}

export default { orderInfo }
